import type { Reducer } from 'redux';

import type { AudienceActivityLoadAction } from '../../domains/audienceActivity/actions.types';

import type { AudienceActivityLifecycle } from './types';

const initialState: AudienceActivityLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<AudienceActivityLifecycle, AudienceActivityLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.audienceActivity };
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
